import React from 'react';

function Footer() {
    return (
        <section>
            <footer className="bg-primary position-relative bottom-0 start-0 end-0 " style={{ overFlowX: 'hidden' }} >
                <div className="container py-3 text-lg-end me-5 pe-5 text-white">
                    <p>Copyright © <span>{new Date().getFullYear()}</span> Developed by <a className='text-white ' href="https://www.linkedin.com/in/msameer192/" target="_blank" rel="noreferrer noopener"><u> M Sameer (Memon's Production)</u></a>  powered by <a className='text-white' href="https://tbcexperts.com/" target="_blank" rel="noreferrer noopener"> <u> tbcexperts.com </u></a>  </p>
                </div>
            </footer>
        </section>
    );
}

export default Footer;
